import { Component, ChangeDetectionStrategy, input } from '@angular/core';

import { BaseLoadingButton } from '../shared/base-button';
import { MatRipple } from '@angular/material/core';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'hypecast-master-admin-buttons-submit',
  templateUrl: './buttons-submit.component.html',
  styleUrls: ['./buttons-submit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatRipple, MatTooltip, MatProgressSpinner],
})
export class ButtonsSubmitComponent extends BaseLoadingButton {
  readonly tooltipText = input<string>('');

  readonly tooltipDisabled = input<boolean>(false);
}
